<template>
  <v-app>
    <v-content>
      <router-view/>      
    </v-content>
  </v-app>
</template>

<script>

import moment from 'moment'

moment.updateLocale('id', {
    weekdays: [
      "Ahad", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"
    ],
    months : [
      "Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"
    ]
});

moment.updateLocale('ms', {
    weekdays: [
      "Ahad", "Isnin", "Selasa", "Rabu", "Khamis", "Jumat", "Sabtu"
    ],
    months : [
      "Januari", "Februari", "Mac", "April", "Mei", "Jun", "Julai", "Ogos", "September", "Oktober", "November", "Disember"
    ]
});

export default {
  name: 'App',
  data () {
    return {
    }
  },   

  created(){
    // this.$store.commit('clock', this.$moment())
  },

  mounted(){        
    // document.addEventListener("deviceready", this.onDeviceReady, false); 
  },

  sockets:{

    refresh(){
      this.$router.push('/wait')
    },

    reboot(){
      if(process.env.VUE_APP_SERVED == "server"){
        setTimeout(()=>{
          this.axios.post('/123now/reboot')
        }, 1000)
      }
      if(process.env.VUE_APP_SERVED == "client"){        
        this.axios.post('/123now/reboot', {},  { baseURL: "http://localhost:3000"} )
      }      
    },

    poweroff(){
      if(process.env.VUE_APP_SERVED == "server"){
        setTimeout(()=>{
          this.axios.post('/123now/poweroff')
        },1000)        
      }
      if(process.env.VUE_APP_SERVED == "client"){
        this.axios.post('/123now/poweroff', {}, { baseURL: "http://localhost:3000"} )
      }
    }

  },

  methods:{
    // onDeviceReady(){
    //   this.cordova.plugins.autoStart.enable();
    //   this.cordova.plugins.insomnia.keepAwake();
    // }
    
  }

}
</script>
